const useHLVOutput = (user) => {
  const calculateHumanLifeValue = () => {
    const dobDate = new Date(user?.dob);

    // Calculate the age based on the current date
    const currentDate = new Date();
    const ageInMilliseconds = currentDate - dobDate;
    const ageInYears = Math.floor(
      ageInMilliseconds / (365.25 * 24 * 60 * 60 * 1000)
    );

    const age = parseInt(ageInYears);
    const expenses = parseInt(user?.monthlyExpenses);
    const liabilities = parseInt(user?.monthlyLiabilities);
    const savings = parseInt(user?.monthlySavings);

    // Assuming retirement age is provided as input
    const yearsUntilRetirement = parseInt(user?.retirementAge || 60) - age;

    // Calculate the HLV using the specified formula
    // Human Life Value = (Yearly Income x Number of Working Years) + (Yearly Income x Annual Raise x Number of Working Years) - (Monthly Expenses x 12 months x Number of Years)

    const hlv =
      (expenses * 0.75 + liabilities + savings) * 12 * yearsUntilRetirement; //Multiplication factor of expense can be varied and be equal to 0.8 also
    //this is a closer approximation to the icici formula
    //income *0.8*12*yearsUntilRetirement;
    // Update the state with the result
    return hlv.toFixed(2); // Display result with two decimal places
  };

  const calculateSavingsPercentage = () => {
    const savingsPercentage = (user.monthlySavings / user.monthlyIncome) * 100;
    return isNaN(savingsPercentage) ? 0 : savingsPercentage;
  };

  // Chart data for income/savings doughnut graph
  const incomeSavingsData = {
    labels: ["Monthly Income", "Monthly Savings"],
    datasets: [
      {
        data: [Number(user.monthlyIncome), Number(user.monthlySavings)],
        backgroundColor: ["#36A2EB", "#4CAF50"],
        hoverBackgroundColor: ["#2DA1ED", "#43A546"],
      },
    ],
  };

  const calculateFiftyPercentOfSaving = () => {
    const fiftyPercentOfSaving = 0.5 * user.monthlySavings;
    return fiftyPercentOfSaving;
  };

  const humanLifeValue = calculateHumanLifeValue();
  const dataInPercent = [];
  const savingsPercentage = calculateSavingsPercentage();
  const fiftyPercentOfSaving = calculateFiftyPercentOfSaving();
  const options = {
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          var dataset = data.datasets[tooltipItem.datasetIndex];
          var meta = dataset._meta[Object.keys(dataset._meta)[0]];
          var total = meta.total;
          var currentValue = dataset.data[tooltipItem.index];
          var percentage = parseFloat(
            ((currentValue / total) * 100).toFixed(1)
          );
          return currentValue + " (" + percentage + "%)";
        },
        title: function (tooltipItem, data) {
          return data.labels[tooltipItem[0].index];
        },
      },
    },
  };

  // Chart data for HLV distribution
  const incomeBarChartData = {
    labels: ["Income", "Expenses", "Savings", "Liabilities"],
    datasets: [
      {
        label: "Amount",
        backgroundColor: ["#36A2EB", "#FFCE56", "#4CAF50", "#EF4B2E"],
        borderColor: "#fff",
        borderWidth: 1,
        hoverBackgroundColor: ["#36A2EB", "#FFCE56", "#4CAF50", "#EF4B2E"],
        data: [
          user.monthlyIncome,
          user.monthlyExpenses,
          user.monthlySavings,
          user.monthlyLiabilities,
        ],
      },
    ],
  };

  // Chart data for HLV distribution
  const incomeDoughnutData = {
    labels: [
      "Monthly Income",
      "Monthly Expenses",
      "Monthly Savings",
      "Monthly Liabilities",
    ],
    datasets: [
      {
        data: [
          Number(user.monthlyIncome),
          Number(user.monthlyExpenses),
          Number(user.monthlySavings),
          Number(user.monthlyLiabilities),
        ],
        backgroundColor: ["#36A2EB", "#FFCE56", "#4CAF50", "#EF4B2E"],
        hoverBackgroundColor: ["#2DA1ED", "#FFC83B", "#43A546", "#EF4B2E"],
      },
    ],
  };
  return {
    humanLifeValue,
    incomeBarChartData,
    options,
    incomeDoughnutData,
    savingsPercentage,
    incomeSavingsData,
    fiftyPercentOfSaving,
  };
};

export default useHLVOutput;
